import React from "react";
import { Button } from "antd";
import { ModalBase } from "@aspen/ui/modalBase";
import { AI_DISCLAIMER_KEY, i18nCrossUtil, isClient, saveComplianceTag } from "@aspen/libs";

export interface ModalAIDisclaimerProps {
  /**
   * 是否显示弹窗
   */
  visible?: boolean;
  /**
   * 确认按钮点击回调
   */
  onConfirm?: () => void;
  /**
   * 取消按钮点击回调
   */
  onCancel?: () => void;
}

/**
 * AI免责声明弹窗组件
 */
export const ModalAIDisclaimer: React.FC<ModalAIDisclaimerProps> = props => {
  const { visible = false, onConfirm, onCancel } = props;
  const crossIntl = i18nCrossUtil.t();

  // 确认按钮点击
  const handleConfirm = () => {
    if (isClient) {
      saveComplianceTag(AI_DISCLAIMER_KEY);
    }
    onConfirm?.();
  };

  // 取消按钮点击
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <ModalBase
      title={<div className="text-[#FFFFFFD8] font-CommonMedium">{crossIntl["common.notice"]}</div>}
      open={visible}
      footer={null}
      closable
      maskClosable={false}
      onCancel={handleCancel}
      centered
      width={540}>
      <>
        <div className="text-white leading-6">{crossIntl["ai.notice.content"]}</div>

        <div className="flex !justify-end gap-3 pt-4">
          <Button
            type="primary"
            onClick={handleConfirm}
            className="h-10 px-6 bg-[#F5A623] border-[#F5A623] text-white">
            {crossIntl["common.confirm"]}
          </Button>
          <Button
            onClick={handleCancel}
            className="h-10 px-6 bg-transparent border border-gray-500 text-[#FFFFFFB2]">
            {crossIntl["common.cancel"]}
          </Button>
        </div>
      </>
    </ModalBase>
  );
};
